'use client'

import { openEquivalentProductsDrawerAtom } from '@/feature/product/services/equivalentProducts.store'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { useSetAtom } from 'jotai'

export type EquivalentProductsLinkProps = {
  slug: string
  className?: string
}

export function EquivalentProductsLink({
  slug,
  className,
}: EquivalentProductsLinkProps): React.ReactElement {
  const openDrawer = useSetAtom(openEquivalentProductsDrawerAtom)
  const { t } = useTranslation(['equivalentProducts'])

  return (
    <Button
      size="md"
      variant="link"
      iconLeft={<Icon.Eye size="sm" />}
      onPress={() => openDrawer(slug)}
      className={className}
    >
      {t('equivalentProducts:link')}
    </Button>
  )
}
